import { Alert } from 'antd';

/**
 * SHAR-758 (Copilot review) — the same-city rule, stated once.
 *
 * Origin and destination may be corrected to another airport in the SAME city
 * and no further: London LGW → EGLL is a correction, London → Berlin is a
 * different flight at a price the customer never agreed to. The rule has always
 * held for ShareJet bookings (SHAR-332) and now holds for charter bookings too
 * (SHAR-758, Mikhail 4 Sep).
 *
 * Both itinerary editors need to say so, and both were saying so in their own
 * copy of an Alert with the same hand-set background and border. This is that
 * notice, once: the wording and the colours cannot now drift apart on two
 * screens that are enforcing one rule.
 *
 * The colours are set explicitly because the admin theme sets a dark
 * `colorInfo`, which darkens antd's default info background until the text on
 * it is hard to read.
 */
export function SameCityNotice() {
  return (
    <Alert
      type="info"
      showIcon
      style={{
        marginBottom: 16,
        background: '#f0f5ff',
        border: '1px solid #adc6ff',
      }}
      message="Origin and destination can only be changed to another airport within the same city."
    />
  );
}
